import React from "react";
import FreelancerSidebarLayout from "../freelancer/FreelancerSidebarLayout";
import MarketingCampaigns from "./MarketingCampaigns";

const FreelancerMarketingPage = () => {
  return (
    <FreelancerSidebarLayout>
      <MarketingCampaigns />
    </FreelancerSidebarLayout>
  );
};

export default FreelancerMarketingPage;
